import { Flex, Text, Box, Container, Image } from "@chakra-ui/react";
import ButtonSpoleto from "../Button";

const BannerTitle = () => {
  return (
    <>
      <Text
        d={["none", null, "inline-block"]}
        as="span"
        textAlign="left"
        color="#331F12"
        fontFamily="JosefinRegular"
        fontSize={["42px", null, "62px"]}
      >
        ESCOLHA O TEMA <br /> DA{" "}
        <Text
          as="span"
          color="#331F12"
          fontFamily="JosefinBold"
          fontSize={["42px", null, "62px"]}
        >
          COLEÇÃO <br /> DE PRATOS 2022
        </Text>
      </Text>
      <Text
        d={["inline-block", null, "none"]}
        as="span"
        textAlign="left"
        color="#331F12"
        fontFamily="JosefinRegular"
        fontSize={["42px", null, "62px"]}
        width="70%"
      >
        ESCOLHA O TEMA DA{" "}
        <Text
          as="span"
          color="#331F12"
          fontFamily="JosefinBold"
          fontSize={["42px", null, "62px"]}
        >
          COLEÇÃO <br /> DE PRATOS 2022
        </Text>
      </Text>
    </>
  );
};

const Banner = ({ toggleModal }) => {
  return (
    <Box className="banner">
      <Container maxW="container.xl">
        <Flex
          flexDirection="column"
          alignItems={["center", null, "center"]}
          justifyContent={["center", null, "center"]}
          h={["auto", null, "500px"]}
          w="100%"
          color="#fff"
          backgroundColor="transparent"
          py={[12, null, 0]}
          id="banner"
        >
          <Image
            maxW={["80%", null, "100%"]}
            src="assets/images/banner-2022-center.png"
          />
          {/* <Box
            maxW={[null, null, "100%"]}
            textAlign="left"
            lineHeight={["45px", null, "70px"]}
          >
            <BannerTitle />
          </Box>
          <Box
            maxW={[null, null, "65%"]}
            textAlign="left"
            marginTop={["10px", null, "20px"]}
          >
            <Text
              as="span"
              textAlign="left"
              color="#000"
              fontFamily="FiraSansRegular"
              fontSize={["19px", null, "24px"]}
            >
              Dessa vez, quem decide o tema da{" "}
              <strong>Coleção de Pratos</strong> é você! Leia as três propostas
              de tema a seguir e vote naquela que você quer ver decorando a sua
              casa no final do ano.
            </Text>
          </Box>

          <ButtonSpoleto
            marginTop="20px"
            maxWidth={["100%", null, "320px"]}
            onClick={toggleModal}
          >
            Votar nos temas
          </ButtonSpoleto> */}
        </Flex>
      </Container>
    </Box>
  );
};
export default Banner;
